<template>
  <!-- Top toolbar -->
  <div class="toolbar">
    <div class="toolbar-left">
      <k-input
        class="global-search"
        :placeholder="'Search'"
        :icon-name="'search'"
        v-model="searchText"
        :show-clear-button="true"
      >
      </k-input>

      <div class="selected-count">
        <span>{{ selectedRows.length }} Selected</span>
      </div>

      <kbutton
        style="display: none"
        :theme-color="'primary'"
        :disabled="selectedRows.length === 0"
        @click="handleOpenBatchEditForm(true)"
      >
        Batch Edit
      </kbutton>

      <!-- <kbutton :theme-color="'primary'" :disabled="selectedRows.length === 0" @click="handleOpenDeleteConfirmation(true)">
        Edit
      </kbutton> -->

      <kbutton
        :theme-color="'error'"
        :disabled="selectedRows.length === 0"
        @click="handleOpenDeleteConfirmation(true)"
      >
        Delete
      </kbutton>

      <kbutton
        ref="help-button"
        class="help-button"
        :fill-mode="'clear'"
        @click="showHelpContent = !showHelpContent"
      >
        <span class="k-icon k-i-question k-question-lg"></span>
        Help
      </kbutton>

      <Popup
        :anchor="'help-button'"
        :show="showHelpContent"
        :popup-class="'help-content'"
      >
        <help-content
          :closeHelpContent="() => (showHelpContent = !showHelpContent)"
        ></help-content>
      </Popup>
    </div>
  </div>
  <!-- Contact Grid -->
  <Grid
    :data-items="rows"
    :columns="columns"
    :selected-field="selectedField"
    :cell-render="'customCell'"
    @selectionchange="onSelectionChange"
    @headerselectionchange="onHeaderSelectionChange"
    :loader="loader"
    :size="'small'"
    :resizable="true"
  >
    <!-- Rendering custom cells -->
    <template v-slot:customCell="{ props }">
      <td v-if="props.field === 'selected'" style="text-align: center">
        <kcheckbox
          :value="getCellValue(props.field, props.dataItem)"
          @change="(event) => onSelectionChange(event, props.dataItem)"
        />
      </td>

      <td v-if="props.field !== firstColumn && props.field !== 'selected'">
        {{ getCellValue(props.field, props.dataItem) }}
      </td>

      <td
        v-if="props.field === firstColumn"
        class="k-table-td"
        style="left: 0px; right: 0px"
        @click="handleOpenSingleEditForm(true, props.dataItem)"
      >
        <span class="name-cell">{{
          getCellValue(props.field, props.dataItem)
        }}</span>
      </td>
    </template>

    <!-- no csvData found block -->
    <grid-norecords>
      <div v-if="loader === false" class="grid-no-data-found-box">
        <img src="../../assets/no-data-found.jpg" alt="no-data-found" />
        No Data Found!
      </div>
    </grid-norecords>
  </Grid>

  <pager
    :skip="skip"
    :take="take"
    :total="totalRowCount"
    :button-count="5"
    :info="true"
    :previous-next="true"
    :type="'numeric'"
    :page-sizes="pageSizes"
    :page-size="take"
    @pagechange="handlePageChange"
  >
  </pager>

  <!-- Single Add Side Panel Form -->
  <edit-form
    :key="'add'"
    :actionType="'add'"
    :openEditFormFlag="openSingleFormFlag"
    :handleOpenEditForm="handleOpenSingleAddForm"
    :formFieldsValue="formFieldsValue"
    @saveEditForm="saveEditForm"
  ></edit-form>

  <!-- Single Edit Side Panel Form -->
  <edit-form
    :key="'edit'"
    :actionType="'edit'"
    :openEditFormFlag="openSingleEditFormFlag"
    :handleOpenEditForm="handleOpenSingleEditForm"
    :formFieldsValue="formFieldsValue"
    @saveEditForm="saveEditForm"
  ></edit-form>

  <!-- Batch Edit Side Panel Form -->
  <edit-form
    :key="'batch'"
    :actionType="'batch'"
    :openEditFormFlag="openBatchEditFormFlag"
    :handleOpenEditForm="handleOpenBatchEditForm"
    :selectedContactToEdit="selectedContactToEdit"
  ></edit-form>

  <!-- Delete Confirmation -->
  <delete-confirmation
    :selectedRows="selectedRows"
    :openDeleteConfirmationFlag="openDeleteConfirmationFlag"
    :handleOpenDeleteConfirmation="handleOpenDeleteConfirmation"
    @deleteRow="deleteRow"
  ></delete-confirmation>

  <!-- No CSV Message -->
  <no-csv-message
    :openNoCSVMessageFlag="NoCSVMessageFlag"
    :handleOpenNoCSVMessage="handleOpenNoCSVMessage"
  ></no-csv-message>
</template>

// ...existing code...

<script>
import Papa from "papaparse";
import { defineComponent } from "vue";
import { Grid, GridNoRecords } from "@progress/kendo-vue-grid";
import { Pager } from "@progress/kendo-vue-data-tools";
import { Button } from "@progress/kendo-vue-buttons";
import { Input, Checkbox } from "@progress/kendo-vue-inputs";
import { Popup } from "@progress/kendo-vue-popup";

import EditForm from "./edit-form.vue";
import DeleteConfirmationDialog from "./delete-confirmation-dialog.vue";
import NoCSVMessage from "./no-csv-message.vue";
import HelpContent from "./help-content.vue";

export default defineComponent({
  name: "csvLoader2",

  components: {
    Grid,
    pager: Pager,
    Popup,
    "grid-norecords": GridNoRecords,
    kbutton: Button,
    kcheckbox: Checkbox,
    "edit-form": EditForm,
    "delete-confirmation": DeleteConfirmationDialog,
    "no-csv-message": NoCSVMessage,
    "help-content": HelpContent,
    "k-input": Input,
  },

  props: ["hitAddNewData", "changeHitAddNewData", "downloadCSV"],

  data() {
    return {
      windowWidth: 0,
      fileName: "",
      invoiceId: "",
      firstColumn: "",
      staticColumns: [],
      tableData: [],
      csvData: [],
      indexOfSelectedData: "",
      headerSelectionValue: false,
      formFieldsValue: {},
      loader: false,
      sort: [],
      skip: 0,
      take: 50,
      pageNo: 0,
      pageSizes: [50, 100, 200],
      selectedField: "selected",
      openBatchEditFormFlag: false,
      openSingleEditFormFlag: false,
      openSingleFormFlag: false,
      openDeleteConfirmationFlag: false,
      NoCSVMessageFlag: false,
      contactUniqueIdentifier: "Id",
      selectedContactToEdit: null,
      searchText: "",
      showHelpContent: false,
      getInterval: null,
    };
  },

  created() {
   this.loader = this.$route.query.loader === "true";
  },

  async mounted() {
    this.invoiceId = this.$route.query.invoiceId;
    this.windowWidth = screen.width - 88;
    if (this.loader) {
      this.getInterval = setInterval(async () => {
        await this.fetchExistingCSVFile(this.invoiceId);
      }, 2000);
    } else {
      await this.fetchExistingCSVFile(this.invoiceId);
    }
  },

  watch: {
    rows() {
      return this.tableData.slice(this.skip, this.skip + this.take);
    },
    searchText(searchTerm) {
      const results = this.csvData.filter((item) => {
        for (const key in item) {
          if (
            typeof item[key] === "string" &&
            item[key].toLowerCase().includes(searchTerm.toLowerCase())
          ) {
            return true;
          }
        }
        return false;
      });

      this.tableData = results;
      this.resetPagination();
    },
    downloadCSV: async function (newVal) {
      if (newVal === true) {
        await this.exportCSV();
      }
    },
    hitAddNewData: function (val) {
      if (val) {
        let formFieldsValue = {};
        // Use dynamic columns for form fields
        this.staticColumns.forEach((col) => {
          formFieldsValue[col.field] = "";
        });
        this.formFieldsValue = formFieldsValue;
        this.handleOpenSingleAddForm(true);
      }
    },
  },

  computed: {
    rows() {
      let newArr = [];
      for (let i = this.skip; i < this.skip + this.take; i++) {
        if (this.tableData[i]) {
          newArr.push(this.tableData[i]);
        }
      }
      return newArr;
    },

    totalRowCount() {
      return this.tableData.length;
    },

    columns() {
      if (this.staticColumns && this.staticColumns.length) {
        return [
          {
            field: "selected",
            width: "50px",
            headerSelectionValue: this.headerSelectionValue,
          },
          ...this.staticColumns,
        ];
      } else {
        return [
          {
            field: "",
            width: this.windowWidth + 50 + "px",
            headerSelectionValue: this.headerSelectionValue,
          },
        ];
      }
    },

    selectedRows() {
      return this.tableData.filter((item) => item[this.selectedField] === true);
    },
  },

  methods: {
    sortByFirstColumn(data) {
      if (!this.firstColumn) return data;

      return [...data].sort((a, b) => {
        const aVal = String(a[this.firstColumn] ?? "").toLowerCase();
        const bVal = String(b[this.firstColumn] ?? "").toLowerCase();
        return aVal.localeCompare(bVal, undefined, {
          numeric: true,
          sensitivity: "base",
        });
      });
    },
    resetPagination() {
      this.skip = 0;
      this.take = 50;
      this.pageNo = 0;
    },

    async fetchExistingCSVFile(invoiceid) {
      // ...your logic to get CSV file URL...
      // After getting the CSV file URL, call parseCSVFile(url)

      try {
        const url = `${process.env.VUE_APP_BASE_URL}getDocumentStream?APIKey=${process.env.VUE_APP_API_KEY}&invoiceid=${invoiceid}&doctype=5&reducebandwidth=false`;
        const options = {
          method: "GET",
          mode: "cors",
          credentials: "include",
          headers: {
            Accept: "application/json",
          },
        };

        await fetch(url, options)
          .then((response) => response.json())
          .then(async (data) => {
            console.log("data: ", data);
            if (
              data &&
              data.docImage &&
              data.docImage.documentStream &&
              data.docImage.documentStream.length &&
              data.docImage.documentName.includes(".csv")
            ) {
              // console.log("data.blob_url: ", data.blob_url)
              const byteArray = new Uint8Array(data.docImage.documentStream);
              const csvString = new TextDecoder().decode(byteArray);
              await this.parseCSVFile(csvString);
              this.loader = false;

              if (this.getInterval) {
                clearInterval(this.getInterval);
                this.getInterval = null;
              }

              const query = { ...this.$route.query };
              delete query.loader;

              this.$router.replace({
                path: this.$route.path,
                query,
              });
            } else {
              this.NoCSVMessageFlag = true;
              this.handleOpenNoCSVMessage(true);
              console.log("documentStream not found!");
            }
          })
          .catch((error) => console.log("error", error));
      } catch (error) {
        console.log("error: ", error);
      }
    },

    async parseCSVFile(csvString) {
      try {
        const setCSVData = (headers, items) => {
          this.staticColumns = headers;
          this.firstColumn = headers.length ? headers[0].field : "";
          this.csvData = this.sortByFirstColumn(items);
          this.tableData = this.csvData;
          this.resetPagination();
        };

        Papa.parse(csvString, {
          header: true,
          skipEmptyLines: true,
          complete: (results) => {
            if (results.data && results.data.length) {
              const cleanedData = results.data.filter((row) =>
                Object.values(row).some(
                  (value) =>
                    value !== null &&
                    value !== undefined &&
                    String(value).trim() !== "",
                ),
              );

              const firstRow = cleanedData[0] || {};

              const headers = Object.keys(firstRow).map((key) => ({
                field: key,
                editable: false,
                title: key,
                width: "150px",
              }));

              const items = cleanedData.map((row) => ({
                selected: false,
                ...row,
              }));

              console.log(items);
              setCSVData(headers, items);
            } else {
              setCSVData([], []);
            }
          },
          error: (error) => {
            console.log("Parse error: ", error.message);
          },
        });
      } catch (error) {
        console.log("error: ", error);
      }
    },

    async convertToBytes(csvData) {
      const blob = new Blob([csvData], { type: "text/csv" });
      return new Uint8Array(await blob.arrayBuffer());
    },

    async saveEditForm(data) {
      try {
        let formType = data.type;
        let formData = data.data;

        switch (formType) {
          case "add":
            this.csvData.push({ selected: false, ...formData });
            break;
          case "edit":
            this.csvData[this.indexOfSelectedData] = {
              selected: false,
              ...formData,
            };
            break;
        }

        this.csvData = this.sortByFirstColumn(this.csvData);
        this.tableData = this.csvData;

        await this.saveFormData();
        await this.fetchExistingCSVFile(this.invoiceId);
      } catch (error) {
        console.log("error: ", error);
      }
    },

    async saveFormData() {
      try {
        const newData = this.csvData.map((item) => {
          const copy = { ...item };
          delete copy["selected"];
          return copy;
        });
        const csvData = Papa.unparse(newData);
        const bytesData = await this.convertToBytes(csvData);
        const body = Object.values(bytesData);

        let url = `${process.env.VUE_APP_BASE_URL}updateInvoiceImage?APIKey=${process.env.VUE_APP_API_KEY}`;

        const options = {
          method: "POST",
          mode: "cors",
          headers: new Headers({
            "content-type": "application/json",
            accept: "application/json",
          }),
          credentials: "include",
          body: JSON.stringify({
            PictureName: `${this.invoiceId}.csv`,
            PictureStream: body,
          }),
        };

        await fetch(url, options)
          .then((response) => response.json())
          .then(async (data) => {
            if (data && data.url && data.url !== "") {
              await this.parseCSVFile(data.url);
            }
          })
          .catch((error) => console.log("error", error));
      } catch (error) {
        console.log("error: ", error);
      }
    },

    async deleteRow(selectedRows) {
      this.tableData = this.csvData = this.csvData.filter(
        (item) => !selectedRows.includes(item),
      );

      if (!this.csvData.length) {
        this.csvData = [];
        this.staticColumns = [];
      }

      await this.saveFormData();
      await this.fetchExistingCSVFile(this.invoiceId);
      this.headerSelectionValue = false;
      this.openDeleteConfirmationFlag = false;
    },

    async exportCSV() {
      const data = this.csvData.map((item) => {
        const copy = { ...item };
        delete copy["selected"];
        return copy;
      });
      const csvData = Papa.unparse(data, { header: true });

      var blob = new Blob([csvData], { type: "text/csv;charset=utf-8;" });
      if (navigator.msSaveBlob) {
        navigator.msSaveBlob(blob, "exported_data");
      } else {
        var link = document.createElement("a");
        if (link.download !== undefined) {
          var url = URL.createObjectURL(blob);
          link.setAttribute("href", url);
          link.setAttribute("download", "exported_data");
          link.style.visibility = "hidden";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      }

      this.$emit("updateDownloadCSVValue", false);
    },

    getCellValue(fieldName, dataItem) {
      const path = fieldName.split(".");
      let data = dataItem;
      path.forEach((p) => {
        data = data ? data[p] : undefined;
      });
      return data;
    },

    onHeaderSelectionChange(event) {
      let checked = event.event.target.checked;

      for (let i = this.skip; i < this.skip + this.take; i++) {
        if (this.csvData[i]) {
          this.tableData[i] = this.csvData[i] = {
            ...this.csvData[i],
            selected: checked,
          };
        }
      }
    },

    onSelectionChange(event, dataItem) {
      this.headerSelectionValue = false;
      const updatedSelectedContacts = this.csvData.map((row) => {
        if (row === dataItem) {
          return { ...row, selected: event.value };
        } else {
          return row;
        }
      });

      console.log(updatedSelectedContacts);
      this.tableData = this.csvData = [...updatedSelectedContacts];

      const allSelected = this.csvData.filter((row) => !row.selected);
      this.headerSelectionValue = allSelected.length === 0;
    },

    handleOpenDeleteConfirmation(flag) {
      this.openDeleteConfirmationFlag = flag;
    },

    handleOpenNoCSVMessage(flag) {
      this.NoCSVMessageFlag = flag;
    },

    handleOpenBatchEditForm(flag) {
      this.selectedContactToEdit = null;
      this.openBatchEditFormFlag = flag;
      this.openSingleEditFormFlag = false;
    },

    handleOpenSingleAddForm(flag) {
      this.openSingleFormFlag = flag;
      this.changeHitAddNewData(flag);
    },

    handleOpenSingleEditForm(flag, dataItem) {
      if (!flag) {
        this.selectedContactToEdit = null;
      } else {
        this.indexOfSelectedData = this.csvData.findIndex(
          (row) => row == dataItem,
        );
        let formFieldsValue = {};
        for (const key in dataItem) {
          if (key !== "selected") {
            formFieldsValue[key] = dataItem[key];
          }
        }
        this.formFieldsValue = formFieldsValue;
      }
      this.openBatchEditFormFlag = false;
      this.openSingleEditFormFlag = flag;
    },

    sortChangeHandler(e) {
      this.loader = true;
      if (e.sort.length > 0) {
        this.sort = e.sort;
      } else {
        this.sort = [];
      }
    },

    handlePageChange(event) {
      this.skip = event.skip;
      this.take = event.take;
      this.pageNo = event.skip / event.take;
    },
  },
});
</script>

// ...existing code...

<style scoped>
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  margin-bottom: 15px;
}

.toolbar-left {
  display: flex;
  align-items: center;
  gap: 20px;
}

.global-search {
  width: 300px;
  padding: 3px;
}

.selected-count {
  display: flex;
  justify-content: center;
  align-items: center;
}

.selected-count > span {
  font-style: italic;
  color: #0c4271;
  font-weight: 700;
  font-size: 15px;
}

.selected-count .k-button::after {
  background-color: transparent;
}

.help-button {
  font-size: 17px;
}

.help-button::after {
  background-color: transparent;
}

.dialog-btn {
  max-width: 60px;
}

.k-dialog-actions {
  justify-content: end;
}
</style>
